import {
    FETCHED_DESTINATIONS,
    FETCHED_TRIP_FORMATS,
    FETCHED_TYPES_OF_WORK,
    FETCHED_PAGES_TAGS,
} from './types';
import update from 'immutability-helper/index';
import _sortBy from 'lodash/sortBy';

const INITIAL_STATE = {
    allDestinations: [],
    allTripFormats: [],
    allTypesOfWork: [],
    pageTags: [],
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_DESTINATIONS:

            let sortedDestinations = _sortBy(action.destinations, 'display_name');

            return update(state, {
                allDestinations: {$set: sortedDestinations},
            });

        case FETCHED_TRIP_FORMATS:

            let sortedTripFormats = _sortBy(action.tripFormats, 'display_name');

            return update(state, {
                allTripFormats: {$set: sortedTripFormats},
            });

        case FETCHED_TYPES_OF_WORK:

            let sortedTypesOfWork = _sortBy(action.typesOfWork, 'display_name');

            return update(state, {
                allTypesOfWork: {$set: sortedTypesOfWork},
            });

        case FETCHED_PAGES_TAGS:

            return update(state, {
                pageTags: {$set: action.tags},
            });

        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/containers/taxonomy/reducer.js